// extracted by mini-css-extract-plugin
export default {"root":"urT2WH","aboveHeaderSlot":"C7YyP5"};